import { render, staticRenderFns } from "./button-primary.vue?vue&type=template&id=ff971522&scoped=true&"
import script from "./button-primary.vue?vue&type=script&lang=js&"
export * from "./button-primary.vue?vue&type=script&lang=js&"
import style0 from "./button-primary.vue?vue&type=style&index=0&id=ff971522&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff971522",
  null
  
)

export default component.exports